import { DispatcherEvent } from '@carvana/merch-native';
import { Events } from '@carvana/vdp-events';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import accountModalTab from '~/constants/accountModalTab';
import UserContext from '~/context/common/UserContext';
import { EventDetail } from '~/contracts/vdp';
import { useEventElements } from '~/hooks/vdp';
import { useButtonHandler } from '~/hooks/vdp/cta';
import { closeAccountModal, openAccountModal } from '~/utilities/accountModal';
import {
  addEventListeners,
  filterLocalEvents,
  removeEventListeners
} from '~/utilities/browserEvents';

function useEventListeners() {
  const getStarted = useButtonHandler();
  const { triggerFetchUserProfile } = useContext(UserContext);
  const dispatch = useDispatch();
  const eventElements = useEventElements();

  useEffect(() => {
    // Account Modal
    const handleAccountModal = filterLocalEvents(() => {
      openAccountModal({
        callerIdentifier: 'AccountCreationForm',
        nativeOptions: {
          eventDispatch: DispatcherEvent.LogIn,
          eventSource: 'vdp'
        },
        onSuccess: () => {
          closeAccountModal();
        },
        tab: accountModalTab.SignIn
      });
    });

    // Get Started
    const handleGetStarted = filterLocalEvents(() => {
      getStarted();
    });

    // User Profile
    const handleUserProfile = filterLocalEvents<number>(() => {
      triggerFetchUserProfile();
    });

    addEventListeners<CustomEvent<EventDetail>>(eventElements, [
      [Events.AccountModalOpen, handleAccountModal],
      [Events.GetStarted, handleGetStarted],
      [Events.UserProfile, handleUserProfile]
    ]);

    return () => {
      removeEventListeners<CustomEvent<EventDetail>>(eventElements, [
        [Events.AccountModalOpen, handleAccountModal],
        [Events.GetStarted, handleGetStarted],
        [Events.UserProfile, handleUserProfile]
      ]);
    };
  }, [dispatch, eventElements, getStarted, triggerFetchUserProfile]);
}

export default useEventListeners;
